import defaultErrorMap from "./locales/en.js";
var overrideErrorMap = defaultErrorMap;
export { defaultErrorMap };
export function setErrorMap(map) {
    overrideErrorMap = map;
}
export function getErrorMap() {
    return overrideErrorMap;
}
